(function () {
    function isMobileMedia() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function syncVideoPoster(video) {
      if (!video) return;

      var host = video.closest('[data-responsive-video-poster]');
      if (!host) return;

      var poster = isMobileMedia()
        ? host.dataset.mobilePoster || host.dataset.poster || ''
        : host.dataset.poster || '';

      if (poster && video.getAttribute('poster') !== poster) {
        video.setAttribute('poster', poster);
      }
    }

    function initAceiiPresetModes() {
      var sections = document.querySelectorAll('[data-aceii-preset-modes]');

      sections.forEach(function (section) {
      if (section.dataset.initialized === 'true') return;

      section.dataset.initialized = 'true';

      var visual = section.querySelector('.aceii-preset-modes__visual');
      var videoShells = Array.prototype.slice.call(section.querySelectorAll('.aceii-preset-video-shell'));
      var videos = Array.prototype.slice.call(section.querySelectorAll('.aceii-preset-video'));
      var buttons = Array.prototype.slice.call(section.querySelectorAll('.aceii-preset-btn'));
      var progressItems = Array.prototype.slice.call(section.querySelectorAll('.aceii-preset-progress__item'));
      var list = section.querySelector('.aceii-preset-modes__list');
      var modes = buttons
        .map(function (button) {
          return button.getAttribute('data-mode');
        })
        .filter(Boolean);

      if (!modes.length) return;

      videos.forEach(syncVideoPoster);

      var autoDelay = 5200;
      var activeIndex = 0;
      var timer = null;
      var isNavHovering = false;
      var currentMode = modes[0];
      var isSectionActive = false;

      function canRunMedia() {
        return isSectionActive && !document.hidden;
      }

      function loadVideo(video, preload) {
        if (!video) return;

        var didAttachSource = false;

        syncVideoPoster(video);
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = preload || 'metadata';

        if (video.dataset.src && !video.getAttribute('src')) {
          video.setAttribute('src', video.dataset.src);
          didAttachSource = true;
        }

        Array.prototype.slice.call(video.querySelectorAll('source')).forEach(function (source) {
          if (source.dataset.src && !source.getAttribute('src')) {
            source.setAttribute('src', source.dataset.src);
            didAttachSource = true;
          }
        });

        if (didAttachSource || video.readyState === 0) {
          video.load();
        }
      }

      function playVideo(video) {
        if (!video) return;

        loadVideo(video, 'auto');

        var promise = video.play();

        if (promise && typeof promise.catch === 'function') {
          promise.catch(function () {});
        }
      }

      function pauseVideo(video, resetTime) {
        if (!video) return;

        video.pause();

        if (resetTime) {
          try {
            video.currentTime = 0;
          } catch (error) {}
        }
      }

      function pauseAllVideos() {
        videos.forEach(function (video) {
          pauseVideo(video, false);
        });
      }

      function getVideoForMode(mode) {
        var shell = videoShells.filter(function (item) {
          return item.getAttribute('data-mode') === mode;
        })[0];

        return shell ? shell.querySelector('.aceii-preset-video') : null;
      }

      function preloadNextVideo(mode) {
        var modeIndex = modes.indexOf(mode);
        var nextMode = modes[(modeIndex + 1) % modes.length];
        var nextVideo = getVideoForMode(nextMode);

        if (nextVideo && nextMode !== mode) {
          loadVideo(nextVideo, 'metadata');
        }
      }

      function setActiveVideo(mode) {
        videoShells.forEach(function (shell) {
          var isActive = shell.getAttribute('data-mode') === mode;
          var video = shell.querySelector('.aceii-preset-video');

          shell.classList.toggle('is-active', isActive);

          if (video) {
            video.classList.toggle('is-active', isActive);

            if (isActive && canRunMedia()) {
              playVideo(video);
            } else if (!isActive) {
              pauseVideo(video, true);
            }
          }
        });

        if (canRunMedia()) {
          preloadNextVideo(mode);
        }
      }

      function centerActiveButton(button) {
        if (!button || !list || !window.matchMedia('(max-width: 760px)').matches) return;

        if (button === buttons[0]) {
          list.scrollTo({
            left: 0,
            behavior: 'smooth'
          });
          return;
        }

        var listRect = list.getBoundingClientRect();
        var buttonRect = button.getBoundingClientRect();
        var currentScroll = list.scrollLeft;
        var buttonCenter = buttonRect.left - listRect.left + currentScroll + buttonRect.width / 2;
        var targetScroll = buttonCenter - list.clientWidth / 2;

        list.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }

      function updateProgress(mode) {
        var activeProgress = null;

        progressItems.forEach(function (item) {
          var isActive = item.getAttribute('data-mode') === mode;

          item.classList.remove('is-active');
          item.classList.remove('is-running');
          item.style.setProperty('--aceii-progress-duration', autoDelay + 'ms');

          if (isActive) {
            activeProgress = item;
          }
        });

        if (!activeProgress) return;

        activeProgress.classList.add('is-active');
        activeProgress.offsetWidth;

        if (!isNavHovering && canRunMedia()) {
          requestAnimationFrame(function () {
            activeProgress.classList.add('is-running');
          });
        }
      }

      function setMode(mode, restart) {
        if (!mode) return;

        var activeButton = null;

        activeIndex = Math.max(0, modes.indexOf(mode));
        currentMode = mode;

        if (visual) {
          visual.setAttribute('data-mode', mode);
        }

        buttons.forEach(function (button) {
          var isActive = button.getAttribute('data-mode') === mode;
          button.classList.toggle('is-active', isActive);

          if (isActive) {
            activeButton = button;
          }
        });

        setActiveVideo(mode);
        centerActiveButton(activeButton);
        updateProgress(mode);

        if (restart && !isNavHovering) {
          startAuto();
        }
      }

      function startAuto() {
        if (isNavHovering || !canRunMedia()) return;

        stopAuto();

        timer = window.setInterval(function () {
          var nextIndex = (activeIndex + 1) % modes.length;
          setMode(modes[nextIndex], false);
        }, autoDelay);
      }

      function stopAuto() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function pauseProgress() {
        progressItems.forEach(function (item) {
          item.classList.remove('is-running');
        });
      }

      function resumeProgress() {
        updateProgress(modes[activeIndex]);
      }

      buttons.forEach(function (button) {
        var mode = button.getAttribute('data-mode');

        button.addEventListener('mouseenter', function () {
          if (!window.matchMedia('(max-width: 760px)').matches) {
            isNavHovering = true;
            stopAuto();
            pauseProgress();
            setMode(mode, false);
          }
        });

        button.addEventListener('pointerenter', function () {
          if (!window.matchMedia('(max-width: 760px)').matches) {
            isNavHovering = true;
            stopAuto();
            pauseProgress();
            setMode(mode, false);
          }
        });

        button.addEventListener('focus', function () {
          setMode(mode, false);
        });

        button.addEventListener('click', function () {
          setMode(mode, false);
        });
      });

      if (list) {
        list.addEventListener('mouseenter', function () {
          if (!window.matchMedia('(max-width: 760px)').matches) {
            isNavHovering = true;
            stopAuto();
            pauseProgress();
          }
        });

        list.addEventListener('mouseleave', function () {
          if (!window.matchMedia('(max-width: 760px)').matches) {
            isNavHovering = false;
            resumeProgress();
            startAuto();
          }
        });
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAuto();
          pauseProgress();
          pauseAllVideos();
          return;
        }

        if (isSectionActive) {
          setMode(currentMode, false);
          startAuto();
        }
      });

      window.addEventListener('resize', function () {
        videos.forEach(syncVideoPoster);
      });

      setMode(currentMode, false);
      updateProgress(currentMode);

      function activateSection() {
        isSectionActive = true;
        setMode(currentMode, false);

        if (!isNavHovering) {
          startAuto();
        }
      }

      function deactivateSection() {
        isSectionActive = false;
        stopAuto();
        pauseProgress();
        pauseAllVideos();
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              activateSection();
            } else {
              deactivateSection();
            }
          });
        }, {
          root: null,
          rootMargin: '300px 0px',
          threshold: 0.01
        });

        observer.observe(section);
      } else {
        activateSection();
      }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAceiiPresetModes);
    } else {
      initAceiiPresetModes();
    }

    document.addEventListener('shopify:section:load', initAceiiPresetModes);
  })();
